import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Feedback Zone List',
	url: '/feedback_list',
	icon: 'map',
}];

export default class Regions extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>

				<Collections.FeedbackZones
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

			</div>
		);
	}
}

